/**
 * FeaturePath: 會員系統-其它-工具
 * Accountable: Landy Chu, AlexCH Cheng
 */

import React from 'react';
import classnames from 'classnames';

import Button from '../../Button/Button';

import styles from './styles.css';

const InformDialog = ({ className, header, description, approve }) => (
  <div className={classnames(styles.dialog, className)}>
    <div className={styles.title}>
      {header}
    </div>
    <div className={styles.body}>
      {description}
    </div>
    <div className={styles.action}>
      <Button onClick={approve}>
        OK
      </Button>
    </div>
  </div>
);

export default InformDialog;
